import { Component } from '@angular/core';

import { Auth } from '../../auth.service';
import { Fmt } from '../../fmt.service';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css'],
    providers: [
        Auth,
        Fmt
    ]
})
export class NavMenuComponent {
    public currentMenu: MenuList = <MenuList>{};

    public menuList: MenuList[] = [
        // { name: 'ホーム', linkActive: 'link-active', link: '/home', icon: 'home' },
        { name: 'ワークスペース管理', linkActive: 'wsusage', link: '/wsusage', icon: 'home' },
        { name: 'テンプレート管理', linkActive: 'project_template', link: '/project_template', icon: 'gift' },
        { name: 'スーパーバイザ登録', linkActive: 'whitelist', link: '/whitelist', icon: 'user' },
    ];

    constructor(
        public _fmt: Fmt,
        public _auth: Auth
    ) {

    }

    setCurrentMenu(menu: MenuList) {
        this.currentMenu = menu;
    }

    login() {
        window.location.href = '/login'
    }

    logout() {
        this._auth.logout(() => {
            window.location.href = '/login';
        });
    }    
}

export interface MenuList {
    name: string,
    linkActive: string,
    link: string,
    icon: string
}